/*
 * INDRAAZ — send our own add-to-cart forms through the cart drawer.
 *
 * The bundle picker and the sticky bar are plain <form> posts, which navigate
 * to /cart. This intercepts them, posts to /cart/add.js instead, and hands the
 * rendered sections to Dawn's own cart-drawer so the drawer opens in place.
 *
 * If the drawer is not on the page (cart type set to "page"), or anything
 * fails, the form is left to submit normally.
 */
(function () {
  // The tag appears in both the buy box and the sticky bar; bind only once.
  if (window.__idzCartBound) return;
  window.__idzCartBound = true;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionsFor(el) {
    if (typeof el.getSectionsToRender !== 'function') return null;
    return el
      .getSectionsToRender()
      .map(function (section) {
        return section.id;
      })
      .join(',');
  }

  // Same section swap Dawn's renderContents does, minus opening the drawer.
  function renderSections(cart, data) {
    if (!data || !data.sections) return;

    // Removing the last line empties the cart, so the class has to go back on.
    var empty = typeof data.item_count === 'number' && data.item_count === 0;
    cart.classList.toggle('is-empty', empty);
    var inner = cart.querySelector('.drawer__inner');
    if (inner) inner.classList.toggle('is-empty', empty);
    var items = cart.querySelector('cart-drawer-items');
    if (items) items.classList.toggle('is-empty', empty);

    cart.getSectionsToRender().forEach(function (section) {
      var target = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!target || !data.sections[section.id]) return;
      var parsed = new DOMParser()
        .parseFromString(data.sections[section.id], 'text/html')
        .querySelector(section.selector || '.shopify-section');
      if (parsed) target.innerHTML = parsed.innerHTML;
    });

    // Replacing #CartDrawer's innerHTML above destroys and recreates
    // #CartDrawer-Overlay — along with the click-to-close listener Dawn's
    // cart-drawer.js bound to the OLD element in its constructor. Dawn
    // rebinds this itself after its own renderContents(), which this
    // bypasses, so without doing it here too, clicking outside the drawer
    // silently stops closing it after the first add-to-cart.
    if (typeof cart.close === 'function') {
      var overlay = cart.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', cart.close.bind(cart));
    }
  }

  /* ----------------------------------------------------------------------
   * "Pop, hang, fall" add-to-cart animation.
   *
   * Same choreography as the Build Your Own Box page's drop animation
   * (idz-build-a-box.js), reused here for every ordinary product-page add:
   * a copy of the product image hops up, pauses, then falls and is
   * absorbed into the header cart icon, landing right around when the
   * "Adding…" request resolves and the drawer opens — something to watch
   * during the wait instead of a static disabled button.
   * -------------------------------------------------------------------- */

  var prefersReducedMotion =
    typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function findSourceImage(form) {
    // Prefer an image actually related to what's being submitted — the
    // sticky bar's own small thumbnail if that's where this add came from,
    // then the bundle tier picker's current slot image, then the main
    // product gallery's active slide as the universal fallback.
    var scoped =
      (form.closest('.idz-sticky-fallback') || form.closest('.idz-bundle') || document).querySelector('img');
    if (scoped) return scoped;
    return document.querySelector('.product__media-item.is-active img');
  }

  function settleOnce(clone, landingEl, fallbackDelay) {
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      clone.remove();
      if (!landingEl) return;
      landingEl.classList.remove('idz-box__drop-land');
      void landingEl.offsetWidth;
      landingEl.classList.add('idz-box__drop-land');
    }
    clone.addEventListener('transitionend', finish, { once: true });
    window.setTimeout(finish, fallbackDelay);
  }

  function flyToCartIcon(form) {
    var cartIcon = document.querySelector('#cart-icon-bubble');
    var sourceImg = findSourceImage(form);
    if (!cartIcon || !sourceImg || prefersReducedMotion) return;

    var startRect = sourceImg.getBoundingClientRect();
    var endRect = cartIcon.getBoundingClientRect();
    if (startRect.width === 0 || startRect.height === 0) return;

    var clone = sourceImg.cloneNode(false);
    clone.removeAttribute('srcset');
    clone.removeAttribute('sizes');
    clone.style.position = 'fixed';
    clone.style.left = startRect.left + 'px';
    clone.style.top = startRect.top + 'px';
    clone.style.width = startRect.width + 'px';
    clone.style.height = startRect.height + 'px';
    clone.style.margin = '0';
    clone.style.borderRadius = '50%';
    clone.style.objectFit = 'cover';
    clone.style.zIndex = '9999';
    clone.style.pointerEvents = 'none';
    clone.style.opacity = '1';
    clone.style.willChange = 'transform, opacity';
    clone.style.backfaceVisibility = 'hidden';
    clone.style.transition = 'transform 0.35s ease-out';
    document.body.appendChild(clone);

    var deltaX = endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    var deltaY = endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);
    var popUpDistance = Math.max(30, startRect.height * 0.7);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.transform = 'translateY(-' + popUpDistance + 'px) scale(0.55)';
      });
    });

    var popUpFallback = window.setTimeout(startFall, 450);

    clone.addEventListener(
      'transitionend',
      function onPopUp() {
        clone.removeEventListener('transitionend', onPopUp);
        window.clearTimeout(popUpFallback);
        window.setTimeout(startFall, 120);
      },
      { once: true }
    );

    function startFall() {
      clone.style.transition = 'transform 0.8s cubic-bezier(0.55, 0.06, 0.68, 0.19), opacity 0.12s ease 0.7s';
      clone.style.transform = 'translate(' + deltaX + 'px, ' + deltaY + 'px) scale(0.05)';
      clone.style.opacity = '0';
      settleOnce(clone, cartIcon, 900);
    }
  }

  function setBusy(form, busy) {
    var button = form.querySelector('[type="submit"]');
    if (!button) return;
    if (busy) {
      button.dataset.idzLabel = button.dataset.idzLabel || button.textContent.trim();
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = 'Adding…';
    } else {
      button.removeAttribute('aria-busy');
      button.disabled = false;
      if (button.dataset.idzLabel) button.textContent = button.dataset.idzLabel;
    }
  }

  function showError(form, message) {
    var box = form.querySelector('[data-idz-cart-error]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'idz-cart-error';
      box.setAttribute('data-idz-cart-error', '');
      box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = message;
    box.hidden = false;
  }

  function clearError(form) {
    var box = form.querySelector('[data-idz-cart-error]');
    if (box) box.hidden = true;
  }

  /* ----------------------------------------------------------------------
   * "View cart" state.
   *
   * A button flips to "View cart" only when the exact variant it would add is
   * already in the cart. Choosing a different pack flips it back to
   * "Add to cart", because that pack is not in there yet.
   * -------------------------------------------------------------------- */

  var inCart = null; // Set of variant ids, filled from /cart.js

  function labelFor(button) {
    if (button.disabled && button.textContent.trim() === 'Sold out') return;
    var view = button.dataset.mode === 'view';
    var text = view ? button.dataset.viewLabel : button.dataset.addLabel;
    if (text && button.textContent.trim() !== text) button.textContent = text;
    button.classList.toggle('idz-btn--view-cart', view);
  }

  function applyState() {
    document.querySelectorAll('[data-idz-cart-submit]').forEach(function (button) {
      if (inCart && button.dataset.variantId) {
        button.dataset.mode = inCart.has(String(button.dataset.variantId)) ? 'view' : 'add';
      }
      labelFor(button);

      // The stepper stays visible in both modes. Only its floor changes: 0 is
      // allowed once the pack is in the cart (it removes the line), never
      // before, where the value is simply how many to add.
      var form = button.closest('form[data-idz-cart-form]');
      if (!form) return;
      var input = form.querySelector('[data-idz-qty-input]');
      if (!input) return;

      var view = button.dataset.mode === 'view';
      input.min = view ? '0' : '1';
      if (!view && (parseInt(input.value, 10) || 0) < 1) input.value = 1;
    });
  }

  function readCart(data) {
    if (!data || !data.items) return;

    var quantities = {};
    data.items.forEach(function (item) {
      var id = String(item.variant_id || item.id);
      quantities[id] = (quantities[id] || 0) + item.quantity;
    });

    inCart = new Set(Object.keys(quantities));
    applyState();

    // Let the pickers show the real quantity for each variant.
    document.dispatchEvent(new CustomEvent('idz:cart-quantities', { detail: quantities }));
  }

  // Fires when a picker changes which variant is live.
  document.addEventListener('idz:cart-refresh', applyState);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-idz-cart-submit]');
    if (!button || button.dataset.mode !== 'view') return;
    var cart = drawer();
    if (!cart) return; // No drawer — let it behave as a normal submit.
    event.preventDefault();
    if (typeof cart.open === 'function') cart.open();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-idz-cart-form]');
    if (!form) return;

    var cart = drawer();
    var sections = cart ? sectionsFor(cart) : null;
    if (!cart || !sections || !window.routes || !window.routes.cart_add_url) return;

    // Already in the cart: this button opens the drawer, it does not add again.
    var trigger = form.querySelector('[data-idz-cart-submit]');
    if (trigger && trigger.dataset.mode === 'view') {
      event.preventDefault();
      if (typeof cart.open === 'function') cart.open();
      return;
    }

    event.preventDefault();
    clearError(form);
    setBusy(form, true);
    // Fly-to-cart-icon animation on submit is intentionally disabled here —
    // the only add animation wanted is the box-builder's own plus-button
    // "pop into the progress bar" one (idz-build-a-box.js's flyToProgress).
    // flyToCartIcon() is left defined below in case it's wanted again later.

    // The bundle picker (idz-bundle.js) can be adding several distinct
    // variants in one submit, unlike every other form here (one variant,
    // one quantity) — it marks its hidden variant-id inputs with
    // data-idz-bundle-item-id rather than the plain id/quantity pair
    // /cart/add.js's single-item form-encoded endpoint expects, so those
    // go through the JSON items[] endpoint instead. Everything else is
    // untouched.
    var isBundle = form.hasAttribute('data-idz-bundle-form');
    var fetchOptions;

    if (isBundle) {
      var counts = {};
      form.querySelectorAll('[data-idz-bundle-item-id]').forEach(function (input) {
        var id = input.value;
        counts[id] = (counts[id] || 0) + 1;
      });
      var bundleLabelInput = form.querySelector('[data-idz-bundle-label]');
      var bundleLabel = bundleLabelInput ? bundleLabelInput.value : '';
      var bundleMaxInput = form.querySelector('[data-idz-bundle-max]');
      var bundleMax = bundleMaxInput ? bundleMaxInput.value : '';
      var bundleUnitValueInput = form.querySelector('[data-idz-bundle-unit-value]');
      var bundleUnitValue = bundleUnitValueInput ? bundleUnitValueInput.value : '';
      var bundleUnitSuffixInput = form.querySelector('[data-idz-bundle-unit-suffix]');
      var bundleUnitSuffix = bundleUnitSuffixInput ? bundleUnitSuffixInput.value : '';
      var items = Object.keys(counts).map(function (id) {
        var item = { id: id, quantity: counts[id] };
        // Several slots resolving to the SAME variant (a "buy N of this"
        // tier, not different products) merge into one real line at
        // quantity N here — tag it (just a marker, the actual count is
        // always read straight from the real line quantity, never
        // snapshotted, so it can't drift out of sync once the cart's own
        // "{variant} × N" pack selector changes it) so the cart drawer/
        // page can show it as a pack pill instead of a plain quantity
        // number. See cart-drawer.liquid/main-cart-items.liquid. The tier's
        // own label ("30 Days", "Pack of 2") rides along too, so the pill
        // reads with the name the customer actually picked rather than
        // falling back to the variant's own (often just "Default Title").
        //
        // Applied regardless of count — including tier 1 (count 1, no
        // discount) — not just when counts[id] > 1 as this used to be
        // guarded. Tier 1 not carrying these properties was exactly why
        // the cart showed no pack-size selector at all for a line added
        // at the very first tier: with no _Pack property, the cart had
        // no pack data to build that dropdown from, and fell through to
        // the plain-variant selector instead, which also doesn't apply
        // (these products only have one real Shopify variant to begin
        // with) — leaving no size control on that line whatsoever. Every
        // tier now behaves the same way once added.
        item.properties = { _Pack: 'true', '_Pack Size': String(counts[id]) };
        if (bundleLabel) item.properties['_Pack Label'] = bundleLabel;
        if (bundleMax) item.properties['_Pack Max'] = bundleMax;
        // Base unit's own numeric size + suffix (e.g. 15 / "ml") — lets
        // the cart show the pack's TOTAL size too, "30ml (15ml x2)", not
        // just "15ml x2" alone. Blank/omitted when there's no unit label
        // configured for this product.
        if (bundleUnitValue) item.properties['_Pack Unit Value'] = bundleUnitValue;
        if (bundleUnitSuffix) item.properties['_Pack Unit Suffix'] = bundleUnitSuffix;
        return item;
      });
      if (!items.length) {
        setBusy(form, false);
        return;
      }
      fetchOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
      };
    } else {
      var body = new FormData(form);
      body.append('sections', sections);
      body.append('sections_url', window.location.pathname);
      fetchOptions = {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      };
    }

    fetch(window.routes.cart_add_url + '.js', fetchOptions)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          // Shopify returns a status field only when the add failed.
          showError(form, data.description || data.message || 'Sorry, that could not be added.');
          return;
        }
        cart.renderContents(data);

        // This theme puts `is-empty` on <cart-drawer>, but Dawn's own
        // renderContents only clears it from .drawer__inner. Left alone, the
        // CSS keeps collapsing the drawer and the panel renders blank.
        cart.classList.remove('is-empty');
        var inner = cart.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        var items = cart.querySelector('cart-drawer-items');
        if (items) items.classList.remove('is-empty');

        if (typeof cart.open === 'function') cart.open();

        // A tier picker submitted from inside a Quick Add modal (opened
        // via "Choose options" — see idz-cart-upsell.liquid/
        // card-product.liquid) should close that modal once the add
        // actually lands, rather than leaving the modal open on top of
        // the cart drawer it just told to open. quick-add-modal's own
        // hide() (quick-add.js) also restores focus to whatever opened
        // it, so this is the same clean close a manual X click gives.
        var quickAddModal = form.closest('quick-add-modal');
        if (quickAddModal && typeof quickAddModal.hide === 'function') {
          quickAddModal.hide(true);
        }

        // The variant just added is now in the cart, so its button flips and
        // the stepper should show the new total for that line.
        if (!inCart) inCart = new Set();
        if (data.variant_id || data.id) inCart.add(String(data.variant_id || data.id));
        applyState();
        refreshFromServer();
      })
      .catch(function () {
        showError(form, 'Something went wrong. Please try again.');
      })
      .finally(function () {
        setBusy(form, false);
      });
  });

  /* ----------------------------------------------------------------------
   * Quantity changes on a line that is already in the cart.
   *
   * While a button reads "View cart" the stepper is showing the real cart
   * quantity, so editing it should change the cart rather than do nothing.
   * -------------------------------------------------------------------- */

  var changeTimer = null;

  function updateLine(input) {
    var form = input.closest('form[data-idz-cart-form]');
    if (!form) return;

    var trigger = form.querySelector('[data-idz-cart-submit]');
    // Only meaningful when the line already exists.
    if (!trigger || trigger.dataset.mode !== 'view' || !trigger.dataset.variantId) return;

    var cart = drawer();
    var sections = cart ? sectionsFor(cart) : null;
    if (!cart || !sections) return;

    // 0 is a real value here — it removes the line.
    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) {
      quantity = 0;
      input.value = 0;
    }

    input.disabled = true;
    clearError(form);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: String(trigger.dataset.variantId),
        quantity: quantity,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          showError(form, data.description || data.message || 'Could not update the quantity.');
          return;
        }
        // Refresh the drawer in place. renderContents() would also pop the
        // drawer open, which is wrong for an inline quantity edit.
        renderSections(cart, data);
        readCart(data);
      })
      .catch(function () {
        showError(form, 'Could not update the quantity. Please try again.');
      })
      .finally(function () {
        input.disabled = false;
      });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-idz-qty-input]');
    if (!input) return;
    // Debounced so holding the stepper sends one request, not one per tap.
    clearTimeout(changeTimer);
    changeTimer = setTimeout(function () {
      updateLine(input);
    }, 450);
  });

  function refreshFromServer() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(readCart)
      .catch(function () {
        /* Server-rendered state stands. */
      });
  }

  // Liquid renders the initial state, so there is no flash on load. This picks
  // up anything changed elsewhere — the drawer, another tab, a removed line.
  document.addEventListener('DOMContentLoaded', refreshFromServer);
  document.addEventListener('cart:refresh', refreshFromServer);
  document.addEventListener('cart:updated', refreshFromServer);

  // Editing a line inside the drawer publishes through Dawn's pub/sub, so both
  // pickers follow changes made there without a reload.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData && event.cartData.items) {
        readCart(event.cartData);
      } else {
        refreshFromServer();
      }
    });
  }

  applyState();
})();
